import React from "react";
import loader from "../assets/images/loader.gif";

const Loader = ({ withoutImg }) => {
  if (withoutImg) {
    return (
      <main className="w-full h-60 flex justify-center items-center">
        <img src={loader} height="70px" width="70px" alt="loader" />
      </main>
    );
  }

  return (
    <main className="main">
      <img src={loader} height="90px" width="90px" alt="loader" />
    </main>
  );
};

export default Loader;
